import styled from 'styled-components';

export const StyledPaginator = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;
`;